import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { PmsCompany, useInvalidatePmsCompanies } from './get-pms-companies'
import { PMS_ROUTE, PmsProvider } from './pms.constants'

export interface CreatePmsCompanyRequest {
  data: Record<string, string>
  provider: PmsProvider
}

export const createPmsCompany = async ({ data, provider }: CreatePmsCompanyRequest) => {
  const response = await authAPI.post<PmsCompany>(`/${PMS_ROUTE[provider]}`, data)
  return response.data
}

export const useCreatePmsCompany = () => {
  const invalidateCompanies = useInvalidatePmsCompanies()

  return useMutation({ mutationFn: createPmsCompany, onSuccess: invalidateCompanies })
}
